export default (state = {}, action) => {
    switch (action.type) {
        case 'WISH_LIST':
            return {wishListId: action.payload};
        default:
            return state
    }
}